import * as Sentry from '@sentry/vue'

import SegmentService from '@/services/segment.service.js'

import { SEGMENT_FETCH_TRAITS } from '@/store/segment/action.types.js'
import { SEGMENT_SET_TRAITS } from '@/store/segment/mutation.types.js'

import { shouldReportError } from '@/utils/error-monitoring/should-report-error'

const state = {
  traits: {},
}

const actions = {
  async [SEGMENT_FETCH_TRAITS]({ commit }) {
    try {
      const response = await SegmentService.getTraits()
      commit(SEGMENT_SET_TRAITS, response.data)
    } catch (error) {
      // A failure here should not impact the user experience, and users do not need to
      // know that this failed. However, send it to Sentry so we know about it.
      if (shouldReportError(error)) {
        Sentry.captureException(error)
      }
    }
  },
}

const getters = {
  segmentTraits: state => state.traits,
}

const mutations = {
  [SEGMENT_SET_TRAITS](state, traits) {
    state.traits = traits
  },
}

export default {
  state,
  actions,
  getters,
  mutations,
}
